import iosBridge from '../store/ios_bridge'
import request from "./curl";
import content_forward_dialog  from "../components/content_forward_dialog";
import report_issue_dialog  from "../components/report_issue_dialog";
import utility from "./utility";
import microapp_search  from "../components/microapp_search";
import InfiniteLoading from 'vue-infinite-loading';
import media_utility from "./media_utility";

import {
  Facebook,
  Twitter,
  Linkedin,
  Reddit,
  Telegram,
  WhatsApp,
  Email
} from "vue-socialmedia-share";

export default {
  name: 'microapp_buzz',
  components: {
    Facebook,
    Twitter,
    Linkedin,
    Telegram,
    WhatsApp,
    Email,
    Reddit,
    content_forward_dialog,
    report_issue_dialog,
    microapp_search,
    InfiniteLoading
  },
  data () {
    return {
      title:'Buzz',
      dialog: false,
      data:[],
      form_buzz_data:{
        url: '',
        description: ''
      },
      buzz_image:null,
      buzz_image_url:null,
      snackbarTimeOut:1500,
      snackbarMessage:'',
      snackbar:false,
      myStyles:{},
      loading:false,
      buzz_delete_dialog:false,
      buzz_edit_dialog:false,
      action_buzz_id:'',
      buzz_details:{},
      buzz_share_dialog:false,
      share_title:'',
      share_url:'',
      share_email_body:'',
      copy_link_tip_show:'',
      load_buzz:false,
      page:1,
      per_page:5,
      no_records:false,
      forwardDialogShow:false,
      content_forward_data:{},
      reportIssueDialogShow:false,
      buzz_found: true,
      report_issue_data:{},
      search_buzz: '',
      first_time_loader: true,
      infiniteId: +new Date(),
      loader: false,
      search_result: true
    }
  },
  async mounted() {
    //If some text content is shared by a 3rdparty App then show it in the URL Box
    let sharedContentObj = this.$store.getters.externalAppSharedText;
    if (sharedContentObj) {
      if(sharedContentObj.shared_content_data_type != "text"){
        this.snackbarMessage = 'Mesh, currently supports only text sharing in this section';
        this.snackbar = true;
        return;
      }
  
      let sharedContentObjResp = await media_utility.externalContentBuilder(this, sharedContentObj);
      if(!sharedContentObjResp){
        return;
      }

      console.log("sharedContentObjResp:", sharedContentObjResp);      
      let shared_data = sharedContentObjResp.msg;

      if(utility.isValidUrl(shared_data)){
        this.form_buzz_data['url'] = shared_data;
      }
      else{
        this.form_buzz_data['description'] = shared_data; 
      }
      this.$store.commit("setExternalAppSharedText", null);
    }

    this.client_device_height = this.getClientDeviceHeight;
    this.myStyles = {
      height: `${this.client_device_height}px`,
      'overflow-y':'scroll'
    };
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    }
  },
  methods: {
    /**
     * scroll
     */  
    scroll (event) {
      if (Math.ceil(event.target.scrollTop + event.target.clientHeight) >= event.target.scrollHeight-100) {
        if(!this.no_records){ //Paginate does not call again and again if server api records not found  
          this.getBuzzList();
        }
      }
    },
    /**
     * getBuzzList
     */    
    getBuzzList ($state) {
      var buzz_data = new FormData();
      buzz_data.append("chat_user_id", this.userData.user_id);
      buzz_data.append("page", this.page);
      buzz_data.append("per_page", this.per_page);

      if(this.search_buzz) {
        buzz_data.append("search_keyword", this.search_buzz);
      }

      request.curl(this, "buzz_list", buzz_data)
      .then(response => {
        if(response.resp_status){
          response.resp_data.data.forEach((buzz) => {
            this.data.push(buzz);
          });
          
          $state.loaded();
          if(this.data.length == response.resp_data.total_count){
            $state.complete();
          }
          
          this.first_time_loader = false;
          this.page = this.page + 1;

          if(this.search_buzz) {
            this.search_result = true;
          }
        }
        else{
          if(this.page == 1) {
            if(this.search_buzz) {
              this.search_result = false;
            }
            else{
              this.buzz_found = false;
            }
          }

          $state.complete();
          this.first_time_loader = false;
          this.loader = false;
        }
      });
    },
    /**
      * createBuzz
      */
     createBuzz(){
      if(this.form_buzz_data.url =='' && this.form_buzz_data.description == ''){
          this.snackbarMessage = 'Missing Buzz URL or Text. Please provide either of them.';
          this.snackbar = true;
          return;
      }
      
      if(this.form_buzz_data.url !='' && this.form_buzz_data.description != ''){
          this.snackbarMessage = 'Missing Buzz URL or Text. Please provide either of them.';
          this.snackbar = true;
          return;
      }

      if(this.form_buzz_data.url !='' && !utility.isValidUrl(this.form_buzz_data.url)){
          this.snackbarMessage = 'Buzz Url must be valid url';
          this.snackbar = true;
          return;
      }
      
      this.loading  = true;
      var buzz_data = new FormData();
      buzz_data.append("chat_user_id", this.userData.user_id);
      
      if(this.form_buzz_data.url){
        buzz_data.append("buzz_url", this.form_buzz_data.url);
      }

      if(this.form_buzz_data.description){
        buzz_data.append("buzz_text", this.form_buzz_data.description);
      }
      
      if(this.buzz_image){
        buzz_data.append("file", this.buzz_image);
      }

      request.curl(this, "buzz_add", buzz_data)
      .then(response => {
         if(response.resp_status){
           this.$refs.form.reset();
           this.form_buzz_data={
              url: '',
              description: ''
           },
           this.buzz_image = null;
            
           this.dialog=false;
           this.buzz_found = true;
           this.data = [];
           this.page = 1;
           this.infiniteId += 1;
        }
        this.snackbarMessage = response.resp_msg;
        this.snackbar = true;
        this.loading = false;
      });
    },
   /**
     * buzzDelete
     */
    buzzDelete(){
      let buzz_id_index = this.data.findIndex(x => x && x.buzz_id && x.buzz_id === this.action_buzz_id);
      var buzz_data = new FormData();
      buzz_data.append("chat_user_id", this.userData.user_id);
      
      if(this.action_buzz_id){
        buzz_data.append("buzz_id", this.action_buzz_id);
      }
      
      this.loading = true;
      request.curl(this, "buzz_delete", buzz_data)
      .then(response => {
         if(response.resp_status){
            this.$delete(this.data, buzz_id_index);
         }

        this.data = [];
        this.page = 1;
        this.infiniteId += 1;
        this.loading = false;
        this.buzz_delete_dialog = false;
      });
    },
    /**
     * buzz_edit
     */
    buzz_edit(buzz_id){
      this.action_buzz_id=buzz_id;
      this.buzz_image = null;
      this.buzz_image_url = null;
      var buzz_data = new FormData();
      buzz_data.append("chat_user_id", this.userData.user_id);
      
      if(this.action_buzz_id){
        buzz_data.append("buzz_id", this.action_buzz_id);
      }
      
      request.curl(this, "buzz_view", buzz_data)
      .then(response => {
        if(response.resp_status){
           this.buzz_details = response.resp_data;
           if(response.resp_data.buzz_type==1){
            this.buzz_details.buzz_description = '';
           }
           else{
            this.buzz_image =this.buzz_details.buzz_image;
            this.buzz_image_url = this.buzz_details.buzz_image;
           }
           this.buzz_edit_dialog = true;
        }
     });
    },
    /**
     * buzz_save
     */
    buzz_save(){
      let buzz_id_index = this.data.findIndex(x => x && x.buzz_id && x.buzz_id === this.action_buzz_id);
    
      if(this.buzz_details.buzz_url =='' && this.buzz_details.buzz_description == ''){
          this.snackbarMessage = 'Missing Buzz URL or Text. Please provide either of them.';
          this.snackbar = true;
          return;
      }
      
      if(this.buzz_details.buzz_url !='' && this.buzz_details.buzz_description != ''){
          this.snackbarMessage = 'Missing Buzz URL or Text. Please provide either of them.';
          this.snackbar = true;
          return;
      }

      if(this.buzz_details.buzz_url !='' && !utility.isValidUrl(this.buzz_details.buzz_url)){
          this.snackbarMessage = 'Buzz Url must be valid url';
          this.snackbar = true;
          return;
      }

      this.loading  = true;
      var buzz_data = new FormData();
      buzz_data.append("chat_user_id", this.userData.user_id);

      if(this.buzz_details.buzz_url){
        buzz_data.append("buzz_url", this.buzz_details.buzz_url);
      }
      
      if(this.buzz_details.buzz_description){
        buzz_data.append("buzz_text", this.buzz_details.buzz_description);
      }
      
      if(this.buzz_image){
        if(!utility.isValidUrl(this.buzz_image)){
          buzz_data.append("file", this.buzz_image);
        }
      }

      if(this.action_buzz_id){
        buzz_data.append("buzz_id", this.action_buzz_id);
      }
      
      request.curl(this, "buzz_edit", buzz_data).then(response => {
        if(response.resp_status){
          this.data[buzz_id_index] = response.resp_data;
          this.buzz_image = null;
          this.buzz_image_url = null;
        }
        this.loading = false;
        this.buzz_edit_dialog = false;
     });
    },
    /**
     * buzz_share_dialog_open
     */ 
    buzz_share_dialog_open(buzz){
      if(buzz.buzz_type == 0){
        this.share_title = buzz.buzz_description.substring(0, 180);
        this.share_url = process.env.VUE_APP_CONTENT_URL+'/content/buzz/'+buzz.buzz_id;
        this.share_email_body = buzz.buzz_description;
      }
      else{ 
        //Buzz url
        this.share_title = buzz.buzz_title;
        this.share_url = buzz.buzz_url;
        this.share_email_body = buzz.buzz_description;
      }
      
      this.invite_dialog_share();
    },
    /**
     * share_send_dialog_open
     */ 
    share_send_dialog_open(buzz){
      if(buzz.buzz_type==0){
        this.content_forward_data.text_msg = process.env.VUE_APP_CONTENT_URL+'/content/buzz/'+buzz.buzz_id;
      }
      else{ 
        this.content_forward_data.text_msg = buzz.buzz_url;
      }
      
      this.content_forward_data.module = 'buzz';
      this.content_forward_data= this.content_forward_data;
      this.forwardDialogShow = true;
    },
    /**
     * invite_dialog_share
     */    
    invite_dialog_share(){
      //for android in app browser
      if(window.androidBridge){
        window.androidBridge.inviteLink(this.share_url, this.share_email_body);
      }
      else{
        const shareData = {
          title: this.share_title,
          text: this.share_email_body,
          url: this.share_url,
        }
        
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
          //android normal browser
          try {
            navigator.share(shareData);
            
          } 
          catch(err) {
            this.snackbar = true;
            this.err_msg = JSON.stringify(err);
          }

        }
        else if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1 || navigator.userAgent.toLowerCase().indexOf("ipad") > -1){
          //IOS normal browser
          try {
            navigator.share(shareData);
          } 
          catch(err) {
            this.snackbar = true;
            this.err_msg = JSON.stringify(err);
          }
        }
        else{ 
          //all normal browser normal popup
          this.buzz_share_dialog = true;
        }
      }
    },
    /**
     * change_image
     */
    change_image(e){
      var file = e.target.files[0];
      this.buzz_image_url = URL.createObjectURL(file);
      this.buzz_image = file;
    },
    /**
     * copyShareLink
     * Copy the Data
     */
    copyShareLink(){
      let urlElement = document.querySelector('#share-link-url');
      urlElement.setAttribute('type', 'text');
      urlElement.select();

      try {
        document.execCommand('copy');
        this.copy_link_tip_show = true;
      }
      catch (err) {
        this.copy_link_tip_show = false;
      }
      
      /* unselect the range */
      urlElement.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
   /*
    * report_issue_dialog_open
    * 
    */
    report_issue_dialog_open(buzz){
      var report_issue_data = {};
      report_issue_data.module_obj_id = buzz.buzz_id;
      
      if(buzz.buzz_type==0){
        report_issue_data.content_text = process.env.VUE_APP_CONTENT_URL+'/content/buzz/'+buzz.buzz_id;
      }
      else{ 
        report_issue_data.content_text = buzz.buzz_url;
      }

      report_issue_data.module_type = 'buzz';
      this.report_issue_data= report_issue_data;
      this.reportIssueDialogShow = true;
    },
    /*
   * close_search
   *
   */
    close_search() {
      this.search_dialog = false;
    },
    /*
     * search_keyword
     *
     */
    search_keyword(keyword) {
      this.search_buzz = keyword;
      this.page = 1;
      this.data = [];
      this.infiniteId += 1;
    },
    /*
    * open_link
    * 
    */ 
    open_link(buzz){
      let buzz_link = process.env.VUE_APP_CONTENT_URL+'/content/buzz/'+buzz.buzz_id;
      let buzz_url = (buzz.buzz_url) ? buzz.buzz_url : buzz_link;
      if(window.webkit){
        iosBridge.sendMessage({"module":"launchInBrowser", "data":{"url":buzz_url}});          
      }
      else{
        window.open(buzz_url, '_blank');
      }
    }
  },
  watch:{
  },
  filters:{
    formatDate(date_time, format='DD/MM/YYYY') { 
      return utility.get_message_datetime(parseInt(date_time), format)
    }
  }
}
